import { useAuditReportsGetGipMetadataAdvertisers } from '@mi-front/api-v2';
import { DateTimeStr } from '@mi-front/core';

/**
 * Advertisers search for the GIP form via api-v2 audit-reports metadata.
 */
export function useGipAdvertisersQuery(
  params: {
    from: DateTimeStr;
    to: DateTimeStr;
    stations: string[];
    search: string;
  },
  enabled: boolean,
) {
  return useAuditReportsGetGipMetadataAdvertisers(
    { search: params.search },
    {
      query: {
        enabled,
        staleTime: 5 * 60 * 1000,
        select: (advertisers) => advertisers.filter((v) => !!v),
      },
    },
  );
}
